export default function Hero() {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center pt-20"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('https://public.readdy.ai/ai/img_res/72d9c1adc3fb087c8eecc5224a99d3f9.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 drop-shadow-lg">
          Fly Tandem Amateur
        </h1>
        <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto drop-shadow-lg">
          Experience the thrill of tandem paragliding with certified instructor Dario. Soar through the sky and create unforgettable memories.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={scrollToBooking}
            className="bg-sky-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-sky-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Book Your Flight
          </button>
          <button 
            onClick={() => {
              const element = document.getElementById('about');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white/90 text-sky-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-white transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Learn More
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white drop-shadow-lg"></i>
      </div>
    </section>
  );
}
